import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email:'admin@example.com', password:'password' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
      nav('/');
    } catch (err) {
      // error toast already shown by interceptor for non-401 errors
      // 401 is handled gracefully by showing the message from server
      const msg = err?.response?.data?.message;
      if (msg) toast.error(msg);
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-bg" />
      <div className="login-card">
        <div style={{ textAlign:'center',marginBottom:30 }}>
          <div style={{ width:52,height:52,background:'linear-gradient(135deg,var(--accent),var(--accent2))',borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',fontSize:26,margin:'0 auto 14px',boxShadow:'0 8px 24px var(--accentGlow)' }}>💼</div>
          <h1 style={{ fontSize:26,fontWeight:800 }}>QuotePro</h1>
          <p style={{ color:'var(--text2)',fontSize:13,marginTop:5 }}>Sign in to your workspace</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input type="email" className="form-control" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="you@example.com" required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input type="password" className="form-control" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width:'100%',justifyContent:'center',padding:12,fontSize:14,marginTop:4 }} disabled={loading}>
            {loading ? <span className="spinner" /> : '→ Sign In'}
          </button>
        </form>
        <div style={{ marginTop:20,padding:12,background:'var(--bg4)',borderRadius:8,fontSize:11.5,color:'var(--text3)',lineHeight:1.7 }}>
          <strong style={{ color:'var(--text2)' }}>Demo:</strong> admin@example.com / password
        </div>
      </div>
    </div>
  );
}
